/**
 * Utility functions for generating anonymous avatar gradients
 */

/**
 * Generate a dark color string in rgb format with the given opacity
 */
const generateDarkColor = (opacity: number = 1): string => {
  // Generate dark RGB values (0-80 range for darker colors)
  const r = Math.floor(Math.random() * 60);
  const g = Math.floor(Math.random() * 60);
  const b = Math.floor(Math.random() * 80);
  
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

/**
 * Generate a linear gradient with two dark colors
 */
export const generateDarkGradient = (loopId?: string): string => {
  // If loopId is provided, we could use it to generate consistent colors for the same loop
  
  // Generate two dark colors with slight variations
  const color1 = generateDarkColor();
  const color2 = generateDarkColor();
  
  // Generate a random angle for the gradient (0-360 degrees)
  const angle = Math.floor(Math.random() * 360);
  
  return `linear-gradient(${angle}deg, ${color1}, ${color2})`;
};

/**
 * Get predefined dark color gradients with subtle accents
 * These provide a nice variety of dark themed gradients
 */
export const getDarkGradient = (index: number): string => {
  const gradients = [
    'linear-gradient(135deg, #1a1a2e, #16213e)',
    'linear-gradient(135deg, #0f3460, #162447)',
    'linear-gradient(135deg, #1f1f1f, #111827)',
    'linear-gradient(135deg, #2c3e50, #1a1a2a)',
    'linear-gradient(135deg, #252525, #191919)',
    'linear-gradient(135deg, #2d3436, #1e272e)',
    'linear-gradient(135deg, #0f0f0f, #232526)',
    'linear-gradient(135deg, #2c3e50, #111827)',
    'linear-gradient(135deg, #223344, #141e30)',
    'linear-gradient(135deg, #0f2027, #203a43)'
  ];
  
  // Use modulo to cycle through the gradients if index is out of range
  return gradients[Math.abs(index) % gradients.length];
};

/**
 * Get a string hash code to use for consistent color selection
 */
export const getStringHash = (str: string): number => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) - hash) + str.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
};
